import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';
import loggedIn from './modules/logged-in';

// Import common js
import './modules/bundles/common.js';

// Import user related js if loggedIn
if(loggedIn){
  import(/* webpackMode: "lazy" */'./modules/bundles/user'); // jshint ignore:line
}

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();
